/**
 * Rows of the sync lists open on click, but must not do so when the click ends a text selection
 * (copying an id). They are divs with role="button" because browsers do not let you select text
 * inside a <button>.
 */
export const isSelectingText = () =>
  (window.getSelection()?.toString() ?? '') !== '';

/** Enter / Space activate the row like a real button. */
export const onActivateKey = (callback) => (event) => {
  if (event.target !== event.currentTarget) return;
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    callback();
  }
};
